module.exports = __webpack_public_path__ + "img/upload_file.f1075ec7.png";